module.exports = __webpack_public_path__ + "img/banner3.90eda1ab.png";